import { render, staticRenderFns } from "./IssueCreatedByStatisticsTable.vue?vue&type=template&id=772e01b3&scoped=true&"
import script from "./IssueCreatedByStatisticsTable.vue?vue&type=script&lang=js&"
export * from "./IssueCreatedByStatisticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e01b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
